import { DropletsIcon } from './Droplets';

/**
 * Maps a liquidity score (0-10) to the appropriate DropletsIcon.
 */
export function getScoreIcon(score: number | undefined) {
  if (score === undefined || score === null) {
    return <DropletsIcon.Unknown />;
  }
  if (score >= 6) return <DropletsIcon.High />;
  if (score >= 3) return <DropletsIcon.Medium />;
  return <DropletsIcon.Low />;
}
